module.exports = __webpack_public_path__ + "img/grow-with-google-bebras-id.8d80a623.jpg";